import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full max-w-[450px]',
    title: 'heading-xl mb-5',
    text: 'heading-s-bold mb-3 flex items-center gap-2',
    line: '',
    icon: 'mt-[2px]',
    amount: 'whitespace-nowrap',
    info: 'heading-s mt-5 mb-3 cursor-pointer',
    trigger: 'mb-3 flex justify-between',
    city: 'heading-s-bold mx-[3px] uppercase',
    chevron: '-rotate-90',

    characteristicLabel: 'heading-xs',
    characteristicValue: 'flex items-center gap-2',
    characteristicValueText: 'heading-xs text-secondary-hover py-[2.5px]',
    characteristicValuePrice: 'heading-m leading-[1.4] font-bold'
  },
  variants: {
    active: {
      true: {
        chevron: 'rotate-90'
      }
    }
  }
});
